/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Filled Back Icon component.
 */
export const MaterialFilledBackIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='MaterialFilledBackIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M14 7l-5 5 5 5V7z' fill={iconColor}
          fillRule='evenodd'
          clipRule='evenodd' />
      </svg>
    )} />
  );
};

MaterialFilledBackIcon.defaultProps = {
  size  : IconSize.large,
  color : Color.grey1
};

export default MaterialFilledBackIcon;
